import regexify from './regexify';
export default (function () {
  for (var _len = arguments.length, inclusions = new Array(_len), _key = 0; _key < _len; _key++) {
    inclusions[_key] = arguments[_key];
  }

  inclusions = regexify(inclusions);
  return function (name) {
    return inclusions.some(function (inclusion) {
      return inclusion.test(name);
    }) && name;
  };
});